import { Purchase } from '../models/purchase.model';

// export class InitializePurchase {
//     static readonly type = '[Purchase] Initialize';
//     constructor() {}
// }

export class ResetPurchase {
  static readonly type = '[Purchase] Reset';
  constructor() {}
}

export class UpdatePurchase {
  static readonly type = '[Purchase] Update';
  constructor(public payload: Purchase, public sellerId: number) {}
}

export class FinalizePurchase {
  static readonly type = '[Purchase] Finalize';
  constructor(public purchaseId: string, public otc: string) {}
}

export class CancelPurchase {
  static readonly type = '[Purchase] Cancel';
  constructor() {}
}

export class GeneratePurchaseCode {
  static readonly type = '[Purchase] Generate Code';
  constructor() {}
}

// TODO: remove
export class AcceptPurchase {
  static readonly type = '[Purchase] Accept';
  constructor() {}
}

export namespace NewPurchasePayload {
  export interface Application {
    applicationId: number;
    sellerId: number;
  }

  export interface Scheme {
    uid: number;
    sellerId: number;
  }
  export interface QCard {
    cardNumber: number;
    sellerId: number;
  }
}

export class NewPurchase {
  static readonly type = '[Purchase] New';

  constructor(
    public payload:
      | NewPurchasePayload.Application
      | NewPurchasePayload.QCard
      | NewPurchasePayload.Scheme
  ) {}
}

export class UpdateCardDetail {
  static readonly type = '[Purchase] Update Card Detail';
  constructor() {}
}
